"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const internal_1 = require("./internal");
exports.convertBurstTimeToEpochTime = (burstTimestamp) => {
    return (internal_1.GenesisBlockTime + burstTimestamp) * 1000;
};
//# sourceMappingURL=convertBurstTimeToEpochTime.js.map